import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ValidatorFn, Validators} from '@angular/forms';
import {DynamicFormConfig} from '../../../../projects/mydocma/dynamic-form/src/lib/dynamic-form/dynamic-form.config';
import {SelectItem} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/select/select-item';
import {FieldTypeEnum} from '../../../../projects/mydocma/dynamic-form/src/lib/dynamic-field/field-type.enum';
import {DynamicFormReadyEvent} from '../../../../projects/mydocma/dynamic-form/src/lib/events/dynamic-form-ready.event';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ValidationError} from '../../../../projects/mydocma/dynamic-form/src/lib/validation/validation-error';
import {ChipsFieldConfig} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/chips/chips-field.config';
import {
    customChipListValidator
} from '../../../../projects/mydocma/dynamic-form/src/lib/validation/custom-validatror';
import {ChipListStartAddNewEnum, ChipListViewTypeEnum} from '@mydocma/component-library/src/lib/chips';
import {ChipItem} from '@mydocma/component-library/src/lib/chips/chip-item';
import {randomImage2, randomImage3} from './random-image1';
import {FieldHint} from '../../../../projects/mydocma/dynamic-form/src/lib/hint-text/field-hint';
import {
    DateFieldConfig,
    DatePickerModeEnum
} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/date/date-field.config';
import {DateTime} from 'luxon';
import {
    DatetimeFieldConfig
} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/datetime/datetime-field-config';
import {NumberTypeEnum} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/number/number-type.enum';
import {NumberFieldConfig} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/number/number-field.config';
import {
    FlexLayoutConfig
} from '../../../../projects/mydocma/dynamic-form/src/lib/layouts/flex-layout/flex-layout.config';
import {
    SignatureFieldConfig
} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/signature/signature-field.config';
import {signaturePoints} from '../../test-components/signature-test-data';
import {TextAreaFieldConfig, TextFieldConfig} from 'projects/mydocma/dynamic-form/src/public-api';

// import { FieldOrientationEnum } from '@mydocma/dynamic-form/public-api';


@UntilDestroy()
@Component({
    selector: 'app-create-task',
    templateUrl: './modify-form-config.component.html',
    styleUrls: ['./modify-form-config.component.scss']
})
export class ModifyFormConfigComponent implements OnInit, OnDestroy {

    @ViewChild('fieldsTextArea', {static: true})
    public fieldsTextArea;
    dates = [new Date(2022, 3, 5, 0, 0, 0, 0), new Date(2022, 3, 15, 0, 0, 0, 0)];
    public formData: DynamicFormReadyEvent;
    public formGroup;
    public defaultFields = [
        {
            id: 'date1',
            name: 'date1',
            label: {text: 'fields.date1'},
            type: FieldTypeEnum.date,
            tooltip: {text: 'asdasdasdasdas'},
            required: true,
            hidden: false,

            // dateFilter: this.validDate,
            // readonly: true,
            value: new Date(2020, 0, 1),
        } as DateFieldConfig,
        {
            id: 'datetime1',
            name: 'datetime1',
            label: {text: 'fields.datetime1'},
            type: FieldTypeEnum.datetime,
            tooltip: {text: 'asdasdasdasdas'},
            required: true,
            hidden: false,
            // dateFilter: this.validDate,
            // readonly: true,
            value: new Date(2020, 0, 1),
        } as DateFieldConfig,
        {
            id: 'signature',
            name: 'signature',
            type: FieldTypeEnum.signature,
            label: {text: 'signature'},
            required: true,
            disabled: false,
            showSpinners: true,
            // readonly: true,
            // readonly: true,
            // maxDate: new Date(2020, 0, 1),
            hidden: false,
            value: signaturePoints,
            options: {penColor: 'rgb(178,34,34)'}

            // getDateClass: this.setDateClassValue.bind(this),
            // dateFilter: this.validDate.bind(this),
        } as SignatureFieldConfig,
        {
            id: 'searchId',
            name: 'searchId',
            label: {
                text: 'MM.searchId.searchFieldTitle',
                tooltip: ''
            },
            type: FieldTypeEnum.number,
            required: true,
            readonly: false,
            disabled: true,
            clearButtonVisibility: false,
            removeSpinners: true,
            minValue: 1,
            maxValue: 2147483647,
            numberType: NumberTypeEnum.integer,
            class: 'searchId'
        } as NumberFieldConfig,
        // {
        //     id: 'select236',
        //     name: 'select236',
        //     type: FieldTypeEnum.filterSelect,
        //     label: {text: 'fields.select2'},
        //     required: true,
        //     // openOnInit: true,
        //     allowAddItem: false,
        //     value: 2,
        //     // removeClearButton: true,
        //     // readonly: true,
        //     // multiline: true,
        //     groupedSource: true,
        //     hint: {text: 'Kyiv', class: 'custom-class', icon: {iconName: 'remove', outlined: true}} as FieldHint,
        //     source: [
        //
        //         {id: 2, text: '3333c', data: {id: 2, text: 'text2'}},
        //         {id: 3, text: 'london is a capital of great brittain', data: {id: 3, text: 'text2'}},
        //     ],
        //
        // },
        // = [
        {
            id: 'time1',
            name: 'time1',
            type: FieldTypeEnum.time,
            label: {text: 'fields.time1'},
            required: false,
            disabled: false,
            // readonly: true,
            // readonly: true,
            // maxDate: new Date(2020, 0, 1),
            hidden: false,
            // getDateClass: this.setDateClassValue.bind(this),
            // dateFilter: this.validDate.bind(this),
            // value: new Date(2020, 0, 1), // "12:00"
            // value: '12:00',
            useTextInput: true,
            showClearButton: true,
            value: '02:23'
        },
        // {

        //     id: 'select55',
        //     name: 'select55',
        //     type: FieldTypeEnum.filterSelect,
        //     label: {text: 'fields.select4'},
        //     required: true,
        //     openOnInit: true,
        //     allowAddItem: true,
        //     tooltip: {text: 'asdasdasdasdas'},
        //     sourceItemComponent: ButtonDropdownComponent,
        //     // valueItemComponent: ButtonDropdownComponent,
        //     // value: 1,
        //     // readonly: true,
        //     // customSearch: this.customSearchFn.bind(this),
        //     // multiline: true,
        //     source: [
        //         {id: 1, text: '1212', data: {id: 1, text: 'text1'}},
        //         {id: 2, text: '3333c', data: {id: 2, text: 'text2'}},
        //         {id: 3, text: 'london is a capital of great brittain', data: {id: 3, text: 'text2'}},
        //         {
        //             id: 4,
        //             text: 'Estonia (Estonian: Eesti [ˈeːsʲti] (listen)), officially the Republic of Estonia (Estonian: Eesti Vabariik), is a country in Northern Europe. It is bordered to the north by the Gulf of Finland across from Finland, to the west by the Baltic Sea across from Sweden, to the south by Latvia, and to the east by Lake Peipus and Russia. The territory of Estonia consists of the mainland, the larger islands of Saaremaa and Hiiumaa, and over 2,200 other islands and islets on the eastern coast of the Baltic Sea,[9] covering a total area of 45,339 square kilometres (17,505 sq mi).[10] The capital city Tallinn and Tartu are the two largest urban areas of the country. The Estonian language is the autochthonous and the official language of Estonia; it is the first language of the majority of its population, as well as the world\'s second most spoken Finnic language'
        //         },
        //         {
        //             id: 5,
        //             text: 'Estonia is a developed country, with a high-income advanced economy; ranking very high in the Human Development Index.[12] The sovereign state of Estonia is a democratic unitary parliamentary republic, administratively subdivided into 15 maakond (counties). With a population of just over 1.3 million, it is one of the least populous members of the European Union, the Eurozone, the OECD, the Schengen Area, and NATO. Estonia has consistently ranked highly in international rankings for quality of life,[13] education,[14] press freedom, digitalisation of public services[15][16] and the prevalence of technology companies.[17]'
        //         },
        //         {
        //             id: 6,
        //             text: 'lalalalalla',
        //             data: {id: 6, text: 'lalalalallalalalalallalalalalallalalalalallalalalalalla'}
        //         },
        //         {id: 7, text: 'Ukraine', data: {id: 2, text: 'Kyiv'}},
        //         {id: 8, text: '1212', data: {id: 1, text: 'text1'}},
        //         {id: 9, text: '3333c', data: {id: 2, text: 'text2'}},
        //         {id: 10, text: 'london is a capital of great brittain', data: {id: 3, text: 'text2'}},
        //         {
        //             id: 11,
        //             text: 'Estonia (Estonian: Eesti [ˈeːsʲti] (listen)), officially the Republic of Estonia (Estonian: Eesti Vabariik), is a country in Northern Europe. It is bordered to the north by the Gulf of Finland across from Finland, to the west by the Baltic Sea across from Sweden, to the south by Latvia, and to the east by Lake Peipus and Russia. The territory of Estonia consists of the mainland, the larger islands of Saaremaa and Hiiumaa, and over 2,200 other islands and islets on the eastern coast of the Baltic Sea,[9] covering a total area of 45,339 square kilometres (17,505 sq mi).[10] The capital city Tallinn and Tartu are the two largest urban areas of the country. The Estonian language is the autochthonous and the official language of Estonia; it is the first language of the majority of its population, as well as the world\'s second most spoken Finnic language'
        //         },
        //         {
        //             id: 12,
        //             text: 'Estonia is a developed country, with a high-income advanced economy; ranking very high in the Human Development Index.[12] The sovereign state of Estonia is a democratic unitary parliamentary republic, administratively subdivided into 15 maakond (counties). With a population of just over 1.3 million, it is one of the least populous members of the European Union, the Eurozone, the OECD, the Schengen Area, and NATO. Estonia has consistently ranked highly in international rankings for quality of life,[13] education,[14] press freedom, digitalisation of public services[15][16] and the prevalence of technology companies.[17]'
        //         },
        //         {
        //             id: 13,
        //             text: 'lalalalalla',
        //             data: {id: 6, text: 'lalalalallalalalalallalalalalallalalalalallalalalalalla'}
        //         },
        //         {id: 14, text: 'Ukraine', data: {id: 2, text: 'Kyiv'}},
        //     ],
        //
        // },
        //
        //     {
        //         id: 'select2555',
        //         name: 'select2555',
        //         type: FieldTypeEnum.filterSelect,
        //         label: {text: 'fields.select2'},
        //         required: true,
        //         openOnInit: true,
        //         allowAddItem: false,
        //         value: 1,
        //         tooltip: {text: 'asdasdasdasdas'},
        //         removeClearButton: true,
        //         // readonly: true,
        //         // multiline: true,
        //         groupedSource: true,
        //         hint: {text: 'Kyiv', class: 'custom-class', icon: {iconName: 'remove', outlined: true}} as FieldHint,
        //         source: [
        //             {
        //                 id: 1, text: 'Test1', data: {id: 1, text: 'text1'}, items: [
        //                     {id: 1, text: 'Yura'},
        //                     {
        //                         id: 4,
        //                         text: 'Estonia (Estonian: Eesti [ˈeːsʲti] (listen)), officially the Republic of Estonia (Estonian: Eesti Vabariik), is a country in Northern Europe. It is bordered to the north by the Gulf of Finland across from Finland, to the west by the Baltic Sea across from Sweden, to the south by Latvia, and to the east by Lake Peipus and Russia. The territory of Estonia consists of the mainland, the larger islands of Saaremaa and Hiiumaa, and over 2,200 other islands and islets on the eastern coast of the Baltic Sea,[9] covering a total area of 45,339 square kilometres (17,505 sq mi).[10] The capital city Tallinn and Tartu are the two largest urban areas of the country. The Estonian language is the autochthonous and the official language of Estonia; it is the first language of the majority of its population, as well as the world\'s second most spoken Finnic language'
        //                     },
        //                     {
        //                         id: 5,
        //                         text: 'asdasdasd'
        //                     }
        //                 ]
        //             },
        //             {id: 2, text: '3333c', data: {id: 2, text: 'text2'}},
        //             {id: 3, text: 'london is a capital of great brittain', data: {id: 3, text: 'text2'}},
        //             {
        //                 id: 4,
        //                 text: 'Estonia (Estonian: Eesti [ˈeːsʲti] (listen)), officially the Republic of Estonia (Estonian: Eesti Vabariik), is a country in Northern Europe. It is bordered to the north by the Gulf of Finland across from Finland, to the west by the Baltic Sea across from Sweden, to the south by Latvia, and to the east by Lake Peipus and Russia. The territory of Estonia consists of the mainland, the larger islands of Saaremaa and Hiiumaa, and over 2,200 other islands and islets on the eastern coast of the Baltic Sea,[9] covering a total area of 45,339 square kilometres (17,505 sq mi).[10] The capital city Tallinn and Tartu are the two largest urban areas of the country. The Estonian language is the autochthonous and the official language of Estonia; it is the first language of the majority of its population, as well as the world\'s second most spoken Finnic language'
        //             },
        //             {
        //                 id: 5,
        //                 text: 'Estonia is a developed country, with a high-income advanced economy; ranking very high in the Human Development Index.[12] The sovereign state of Estonia is a democratic unitary parliamentary republic, administratively subdivided into 15 maakond (counties). With a population of just over 1.3 million, it is one of the least populous members of the European Union, the Eurozone, the OECD, the Schengen Area, and NATO. Estonia has consistently ranked highly in international rankings for quality of life,[13] education,[14] press freedom, digitalisation of public services[15][16] and the prevalence of technology companies.[17]'
        //             },
        //             {
        //                 id: 6,
        //                 text: 'lalalalalla',
        //                 data: {id: 6, text: 'lalalalallalalalalallalalalalallalalalalallalalalalalla'}
        //             },
        //             {id: 7, text: 'Ukraine', data: {id: 2, text: 'Kyiv'}},
        //             {id: 8, text: '1212', data: {id: 1, text: 'text1'}},
        //             {id: 9, text: '3333c', data: {id: 2, text: 'text2'}},
        //             {id: 10, text: 'london is a capital of great brittain', data: {id: 3, text: 'text2'}},
        //             {
        //                 id: 11,
        //                 text: 'Estonia (Estonian: Eesti [ˈeːsʲti] (listen)), officially the Republic of Estonia (Estonian: Eesti Vabariik), is a country in Northern Europe. It is bordered to the north by the Gulf of Finland across from Finland, to the west by the Baltic Sea across from Sweden, to the south by Latvia, and to the east by Lake Peipus and Russia. The territory of Estonia consists of the mainland, the larger islands of Saaremaa and Hiiumaa, and over 2,200 other islands and islets on the eastern coast of the Baltic Sea,[9] covering a total area of 45,339 square kilometres (17,505 sq mi).[10] The capital city Tallinn and Tartu are the two largest urban areas of the country. The Estonian language is the autochthonous and the official language of Estonia; it is the first language of the majority of its population, as well as the world\'s second most spoken Finnic language'
        //             },
        //             {
        //                 id: 12,
        //                 text: 'Estonia is a developed country, with a high-income advanced economy; ranking very high in the Human Development Index.[12] The sovereign state of Estonia is a democratic unitary parliamentary republic, administratively subdivided into 15 maakond (counties). With a population of just over 1.3 million, it is one of the least populous members of the European Union, the Eurozone, the OECD, the Schengen Area, and NATO. Estonia has consistently ranked highly in international rankings for quality of life,[13] education,[14] press freedom, digitalisation of public services[15][16] and the prevalence of technology companies.[17]'
        //             },
        //             {
        //                 id: 13,
        //                 text: 'lalalalalla',
        //                 data: {id: 6, text: 'lalalalallalalalalallalalalalallalalalalallalalalalalla'}
        //             },
        //             {id: 14, text: 'Ukraine', data: {id: 2, text: 'Kyiv'}},
        //         ],
        //
        //     },
        //
        //     {
        //         id: 'select23',
        //         name: 'select23',
        //         type: FieldTypeEnum.filterSelect,
        //         label: {text: 'fields.select2'},
        //         required: true,
        //         // openOnInit: true,
        //         allowAddItem: false,
        //         value: null,
        //         // removeClearButton: true,
        //         // readonly: true,
        //         // multiline: true,
        //         groupedSource: true,
        //         hint: {text: 'Kyiv', class: 'custom-class', icon: {iconName: 'remove', outlined: true}} as FieldHint,
        //         source: [
        //             {id: 7, text: 'Ukraine Ä', data: {id: 2, text: 'Kyiv'}},
        //             {id: 8, text: '1212 Ü', data: {id: 1, text: 'text1'}},
        //             {id: 9, text: '3333c', data: {id: 2, text: 'text2'}},
        //             {id: 10, text: 'london is a capital of great brittain', data: {id: 3, text: 'text2'}},
        //             {id: 17, text: 'Ukraine', data: {id: 2, text: 'Kyiv'}},
        //             {id: 18, text: '1212', data: {id: 1, text: 'text1'}},
        //             {id: 19, text: '3333c', data: {id: 2, text: 'text2'}},
        //             {id: 20, text: 'london is a capital of great brittain', data: {id: 3, text: 'text2'}},
        //
        //             {id: 21, text: 'vlvivi', data: {id: 2, text: 'text2'}},
        //             {id: 31, text: 'london is a capital of great brittain', data: {id: 3, text: 'text2'}},
        //         ],
        //
        //     },

        //     {
        //         id: 'select233',
        //         name: 'select233',
        //         type: FieldTypeEnum.filterSelect,
        //         label: {text: 'fields.select2'},
        //         required: true,
        //         // openOnInit: true,
        //         allowAddItem: false,
        //         value: null,
        //         // removeClearButton: true,
        //         // readonly: true,
        //         // multiline: true,
        //         groupedSource: true,
        //         hint: {text: 'Kyiv', class: 'custom-class', icon: {iconName: 'remove', outlined: true}} as FieldHint,
        //         source: [
        //
        //             {id: 6, text: '3333c', data: {id: 2, text: 'text2'}},
        //             {id: 8, text: 'london is a capital of great brittain', data: {id: 3, text: 'text2'}},
        //         ],
        //
        //     },

        //     {
        //         id: 'date1',
        //         name: 'date1',
        //         type: FieldTypeEnum.date,
        //         label: {text: 'fields.date1'},
        //         required: false,
        //         disabled: false,
        //         // readonly: true,
        //         // readonly: true,
        //         // maxDate: new Date(2020, 0, 1),
        //         hidden: false,
        //         // getDateClass: this.setDateClassValue.bind(this),
        //         // dateFilter: this.validDate.bind(this),
        //         value: new Date(2020, 0, 1),
        //     },
        //     {
        //         id: 'number1',
        //         name: 'number1',
        //         type: FieldTypeEnum.number,
        //         label: {text: 'fields.number1'},
        //         value: 3912393.21212121212,
        //         clearButtonVisibility: true,
        //         // removeSpinners: true,
        //         // valuePosition: 'center',
        //         // incrementButtons: true,
        //         required: true,
        //         maxValue: 50,
        //         minValue: 10,
        //         numberType: NumberTypeEnum.currency,
        //     },
        //
        //     {
        //         id: 'slideToggle3',
        //         name: 'slideToggle3',
        //         type: FieldTypeEnum.multiOption,
        //         tooltip: {text: 'asdasdasdasdas'},
        //         label: null,
        //         class: 'additional-class',
        //         optionType: MultipleOptionType.slideToggle,
        //         source: {
        //             option1: 'Kyiv',
        //             option2: 'Lviv',
        //             option3: 'Cherkassy'
        //         },
        //
        //         initialValue: {
        //             option2: true,
        //             option3: true
        //         },
        //         outlineHidden: true,
        //         // orientation: FieldOrientationEnum.horizontal,
        //         labelPosition: LabelPositionEnum.after
        //     } as MultiOptionConfig,
        {
            id: 'text1',
            name: 'text1',
            type: FieldTypeEnum.text,
            label: {text: 'fields.text1'},
            required: true,
            validators: [Validators.email],
            // maxLength: 12,
            hideClearButton: true,
            // readonly: true,
            // showClearButtonIfReadonly: true,
            minLength: 3,
            hint: {text: 'Kyiv', class: 'custom-class', icon: {iconName: 'remove', outlined: true}} as FieldHint,
            class: 'mydocma-ignore-readonly',
            suffix: {
                tooltip: 'it is tooltop',
                icon: {iconName: 'remove', outlined: false},
                readonly: false
            },
            // showClearButtonIfReadonly: true,
            hidden: false,
            // validators: [this.badWordValidator.bind(this)],
            // asyncValidators: [this.allBadWordValidator.bind(this)],
            prefix: {
                tooltip: 'it is tooltop',
                icon: 'search',
                // readonly: false
            }
        },
        //     {
        //         id: 'date1',
        //         name: 'date1',
        //         type: FieldTypeEnum.date,
        //         label: {text: 'fields.date1'},
        //         required: false,
        //         disabled: false,
        //         // readonly: true,
        //         // readonly: true,
        //         // maxDate: new Date(2020, 0, 1),
        //         hidden: false,
        //         // getDateClass: this.setDateClassValue.bind(this),
        //         // dateFilter: this.validDate.bind(this),
        //         value: new Date(2020, 0, 1),
        //     } as DateFieldConfig,
        //
        //     {
        //         id: 'buttonToggle',
        //         name: 'buttonToggle',
        //         type: FieldTypeEnum.buttonToggle,
        //         label: {text: 'asdasdasd'},
        //         // required: true,
        //         tooltip: {text: 'asdasdasdasdas'},
        //         buttons: {
        //             option1: {text: 'Kyiv', class: 'test-class'},
        //             option2: {text: 'Lvov'},
        //         },
        //         // value: {option2: true}
        //     } as ButtonToggleFieldConfig,
        //     {
        //         id: 'number1',
        //         name: 'number1',
        //         type: FieldTypeEnum.number,
        //         label: {text: 'fields.number1'},
        //         value: 0,
        //         // clearButtonVisibility: true,
        //         // removeSpinners: true,
        //         // valuePosition: 'center',
        //         // incrementButtons: true,
        //         required: true,
        //         // required: true,
        //         // maxValue: 50,
        //         // minValue: 10,
        //         numberType: NumberTypeEnum.currency,
        //         // readonly: true,
        //         // incrementButtons: true,
        //         // readonly: true,
        //         // minValue: 1,1
        //         // maxValue: 4,
        //         // inputReadonly: true,
        //
        //     } as NumberFieldConfig
        //     ,
        //     {
        //         id: 'select1',
        //         name: 'select1',
        //         type: FieldTypeEnum.select,
        //         label: {text: 'fields.select1'},
        //         required: true,
        //
        //         value: 'item1',
        //         source: [
        //             {id: 'item1', text: 'fields.select1'}, {id: 'item2', text: '2'}
        //         ],
        //         // getSource: this.getSelectSource
        //     },
        //     {
        //         id: 'number1',
        //         name: 'number1',
        //         type: FieldTypeEnum.number,
        //         // label: {text: 'fields.number1'},
        //         value: 0,
        //         clearButtonVisibility: true,
        //         removeSpinners: true,
        //         valuePosition: 'center',
        //         incrementButtons: true,
        //         required: true,
        //         // required: true,
        //         // maxValue: 50,
        //         // minValue: 10,
        //         numberType: NumberTypeEnum.integer,
        //         // readonly: true,
        //         // incrementButtons: true,
        //         // readonly: true,
        //         // minValue: 1,1
        //         // maxValue: 4,
        //         // inputReadonly: true,
        //
        //     } as NumberFieldConfig,
        //
        //     {
        //         id: 'text1',
        //         name: 'text1',
        //         type: FieldTypeEnum.text,
        //         label: {text: 'fields.text1'},
        //         required: true,
        //         maxLength: 12,
        //         readonly: false,
        //         minLength: 3,
        //         suffix: {
        //             tooltip: 'it is tooltop',
        //             icon: 'search',
        //             readonly: true
        //         },
        //         // showClearButtonIfReadonly: true,
        //         hidden: false,
        //         // validators: [this.badWordValidator.bind(this)],
        //         // asyncValidators: [this.allBadWordValidator.bind(this)],
        //         prefix: {
        //             tooltip: 'it is tooltop',
        //             icon: 'search',
        //             // readonly: false
        //         }
        //     } as TextFieldConfig,
        //     {
        //         id: 'button2',
        //         name: 'button2',
        //         type: FieldTypeEnum.button,
        //         label: {text: 'Update field value'},
        //         hidden: false,
        //         // click: this.onButtonClick.bind(this),
        //         readonly: false,
        //         buttonClass: 'asdasd'
        //     } ,
        //
        {
            id: 'textarea1',
            name: 'textarea1',
            type: FieldTypeEnum.textarea,
            label: {text: 'Text area with autocomplete and maxRows=5'},
            required: false,
            readonly: false,
            autosize: true,
            hidden: false,
            autocompleteConfig: {
                class: 'custom-autocomplete-dropdown',
                autoActiveFirstOption: true,
                triggerStart: '{{',
                triggerEnd: '}}',
                ignoreValidation: false,
                groupedItems: [
                    {
                        label: 'Main',
                        items: [
                            {value: 'tetswert', description: 'moin'},
                            {value: 'B', description: 'B', disabled: true},
                            {value: 'C', description: 'C'},
                            {value: 'D', description: 'D'},
                            {value: 'E', description: 'E'},
                            {value: 'F', description: 'F'},
                            {value: 'G', description: 'G'},
                            {value: 'H', description: 'H'},
                            {value: 'I', description: 'I'},
                            {value: 'J', description: 'J'},
                            {value: 'K', description: 'K'},
                        ]
                    },
                    {
                        label: 'System fields',
                        disabled: true,
                        items: [
                            {value: 'Today', description: 'Today (date)'}
                        ]
                    },
                ]
            },
            maxRows: 5
        } as TextAreaFieldConfig,
        {
            id: 'textarea2',
            name: 'textarea2',
            type: FieldTypeEnum.textarea,
            label: {text: 'Text area with autocomplete and no max rows'},
            required: false,
            readonly: false,
            autosize: true,
            hidden: false,
            autocompleteConfig: {
                class: 'custom-autocomplete-dropdown',
                autoActiveFirstOption: true,
                triggerStart: '{{',
                triggerEnd: '}}',
                ignoreValidation: false,
                dropdownCriticalWidth: 280,
                items: [
                    {value: 'Project.number', description: 'Projektname'},
                    {value: 'Project.name', description: 'Besprechungsname'},
                    {value: 'Meeting.name', description: 'Besprechungsname'},
                    {value: 'Minutes.number', description: 'Protokollnummer'},
                    {value: 'Minutes.date', description: 'Protokolldatum'},
                    {value: 'Minutes.datetime', description: 'Protokolldatum und -uhrzeit'},
                    {value: 'Minutes.creator', description: 'Protokollersteller'},
                    {value: 'Minutes.sender', description: 'Protokollabsender'},
                    {value: 'Minutes.status', description: 'Protokollstatus'},
                ]
            },
        } as TextAreaFieldConfig,
        {
            id: 'textWithAutocomplete',
            name: 'textWithAutocomplete',
            type: FieldTypeEnum.text,
            label: {text: 'Text field with autocomplete'},
            required: false,
            readonly: false,
            hidden: false,
            placeholder: 'Type {{ to see options',
            autocompleteConfig: {
                class: 'custom-autocomplete-dropdown',
                autoActiveFirstOption: true,
                triggerStart: '{{',
                triggerEnd: '}}',
                ignoreValidation: false,
                groupedItems: [
                    {
                        label: 'Main',
                        items: [
                            {value: 'tetswert', description: 'moin'},
                            {value: 'B', display: 'B', disabled: true},
                            {value: 'C', description: 'C'},
                            {value: 'D', description: 'D'},
                            {value: 'Email', description: 'Email'},
                            {value: 'Name', description: 'Name'},
                        ]
                    },
                    {
                        label: 'System fields',
                        disabled: true,
                        items: [
                            {value: 'Today', description: 'Today (date)'}
                        ]
                    },
                ]
            }
        } as TextFieldConfig,
        //
        //     {
        //         id: 'label1',
        //         name: 'label1',
        //         type: FieldTypeEnum.label,
        //         // class: 'duper-super',
        //         label: {text: 'fields.label1'},
        //         hidden: false,
        //     } as LabelFieldConfig,
        //     {
        //         id: 'select1',
        //         name: 'select1',
        //         type: FieldTypeEnum.select,
        //         label: {text: 'fields.select1'},
        //         required: true,
        //
        //         value: 'item1',
        //         source: [
        //             {id: 'item1', text: '1'}, {id: 'item2', text: '2'}
        //         ],
        //         // getSource: this.getSelectSource
        //     },
        //     {
        //         id: 'select23',
        //         name: 'select23',
        //         type: FieldTypeEnum.filterSelect,
        //         label: {text: 'fields.test'},
        //         required: true,
        //         openOnInit: true,
        //         allowAddItem: false,
        //         // value: 1,
        //         removeClearButton: true,
        //         // readonly: true,
        //         customSearch: this.customSearchFn.bind(this),
        //         // multiline: true,
        //         source: [
        //             {id: 1, text: 'fields.select2', data: {id: 1, text: 'text1'}},
        //             // {id: 2, text: '3333c', data: {id: 2, text: 'text2'}},
        //             // {id: 3, text: 'london is a capital of great brittain', data: {id: 3, text: 'text2'}},
        //             // {
        //             //     id: 4,
        //             //     text: 'Estonia (Estonian: Eesti [ˈeːsʲti] (listen)), officially the Republic of Estonia (Estonian: Eesti Vabariik), is a country in Northern Europe. It is bordered to the north by the Gulf of Finland across from Finland, to the west by the Baltic Sea across from Sweden, to the south by Latvia, and to the east by Lake Peipus and Russia. The territory of Estonia consists of the mainland, the larger islands of Saaremaa and Hiiumaa, and over 2,200 other islands and islets on the eastern coast of the Baltic Sea,[9] covering a total area of 45,339 square kilometres (17,505 sq mi).[10] The capital city Tallinn and Tartu are the two largest urban areas of the country. The Estonian language is the autochthonous and the official language of Estonia; it is the first language of the majority of its population, as well as the world\'s second most spoken Finnic language'
        //             // },
        //             // {
        //             //     id: 5,
        //             //     text: 'Estonia is a developed country, with a high-income advanced economy; ranking very high in the Human Development Index.[12] The sovereign state of Estonia is a democratic unitary parliamentary republic, administratively subdivided into 15 maakond (counties). With a population of just over 1.3 million, it is one of the least populous members of the European Union, the Eurozone, the OECD, the Schengen Area, and NATO. Estonia has consistently ranked highly in international rankings for quality of life,[13] education,[14] press freedom, digitalisation of public services[15][16] and the prevalence of technology companies.[17]'
        //             // },
        //             // {
        //             //     id: 6,
        //             //     text: 'lalalalalla',
        //             //     data: {id: 6, text: 'lalalalallalalalalallalalalalallalalalalallalalalalalla'}
        //             // },
        //             // {id: 7, text: 'Ukraine', data: {id: 2, text: 'Kyiv'}},
        //             // {id: 8, text: '1212', data: {id: 1, text: 'text1'}},
        //             // {id: 9, text: '3333c', data: {id: 2, text: 'text2'}},
        //             // {id: 10, text: 'london is a capital of great brittain', data: {id: 3, text: 'text2'}},
        //             // {
        //             //     id: 11,
        //             //     text: 'Estonia (Estonian: Eesti [ˈeːsʲti] (listen)), officially the Republic of Estonia (Estonian: Eesti Vabariik), is a country in Northern Europe. It is bordered to the north by the Gulf of Finland across from Finland, to the west by the Baltic Sea across from Sweden, to the south by Latvia, and to the east by Lake Peipus and Russia. The territory of Estonia consists of the mainland, the larger islands of Saaremaa and Hiiumaa, and over 2,200 other islands and islets on the eastern coast of the Baltic Sea,[9] covering a total area of 45,339 square kilometres (17,505 sq mi).[10] The capital city Tallinn and Tartu are the two largest urban areas of the country. The Estonian language is the autochthonous and the official language of Estonia; it is the first language of the majority of its population, as well as the world\'s second most spoken Finnic language'
        //             // },
        //             // {
        //             //     id: 12,
        //             //     text: 'Estonia is a developed country, with a high-income advanced economy; ranking very high in the Human Development Index.[12] The sovereign state of Estonia is a democratic unitary parliamentary republic, administratively subdivided into 15 maakond (counties). With a population of just over 1.3 million, it is one of the least populous members of the European Union, the Eurozone, the OECD, the Schengen Area, and NATO. Estonia has consistently ranked highly in international rankings for quality of life,[13] education,[14] press freedom, digitalisation of public services[15][16] and the prevalence of technology companies.[17]'
        //             // },
        //             // {
        //             //     id: 13,
        //             //     text: 'lalalalalla',
        //             //     data: {id: 6, text: 'lalalalallalalalalallalalalalallalalalalallalalalalalla'}
        //             // },
        //             // {id: 14, text: 'Ukraine', data: {id: 2, text: 'Kyiv'}},
        //         ],
        //
        //     } as FilterSelectFieldConfig,
        //     {
        //         id: 'select3',
        //         name: 'select3',
        //         type: FieldTypeEnum.filterSelect,
        //         label: {text: 'fields.select3'},
        //         required: true,
        //         openOnInit: true,
        //         allowAddItem: true,
        //         groupedSource: true,
        //         multiline: true,
        //         value: 'asadasd',
        //         source: [
        //             // {id: 11, text: 'group1', items: [{text: 'item1', id: 1}, {text: 'item2', id: 2}]},
        //             // {id: 12, text: 'group2', items: [{text: 'item3', id: 3}, {text: 'item4', id: 4}]},
        //             {id: 1, text: '1212', data: {id: 1, text: 'text1'}},
        //             // {id: 2, text: '3333c', data: {id: 2, text: 'text2'}},
        //             // {id: 3, text: 'london is a capital of great brittain', data: {id: 3, text: 'text2'}},
        //             // {
        //             //     id: 4,
        //             //     text: 'Estonia (Estonian: Eesti [ˈeːsʲti] (listen)), officially the Republic of Estonia (Estonian: Eesti Vabariik), is a country in Northern Europe. It is bordered to the north by the Gulf of Finland across from Finland, to the west by the Baltic Sea across from Sweden, to the south by Latvia, and to the east by Lake Peipus and Russia. The territory of Estonia consists of the mainland, the larger islands of Saaremaa and Hiiumaa, and over 2,200 other islands and islets on the eastern coast of the Baltic Sea,[9] covering a total area of 45,339 square kilometres (17,505 sq mi).[10] The capital city Tallinn and Tartu are the two largest urban areas of the country. The Estonian language is the autochthonous and the official language of Estonia; it is the first language of the majority of its population, as well as the world\'s second most spoken Finnic language'
        //             // },
        //             // {
        //             //     id: 5,
        //             //     text: 'Estonia is a developed country, with a high-income advanced economy; ranking very high in the Human Development Index.[12] The sovereign state of Estonia is a democratic unitary parliamentary republic, administratively subdivided into 15 maakond (counties). With a population of just over 1.3 million, it is one of the least populous members of the European Union, the Eurozone, the OECD, the Schengen Area, and NATO. Estonia has consistently ranked highly in international rankings for quality of life,[13] education,[14] press freedom, digitalisation of public services[15][16] and the prevalence of technology companies.[17]'
        //             // },
        //             // {
        //             //     id: 6,
        //             //     text: 'lalalalalla',
        //             //     data: {id: 6, text: 'lalalalallalalalalallalalalalallalalalalallalalalalalla'}
        //             // },
        //             // {id: 7, text: 'Ukraine', data: {id: 2, text: 'Kyiv'}},
        //             // {id: 8, text: '1212', data: {id: 1, text: 'text1'}},
        //             // {id: 9, text: '3333c', data: {id: 2, text: 'text2'}},
        //             // {id: 10, text: 'london is a capital of great brittain', data: {id: 3, text: 'text2'}},
        //         ],
        //
        //     } as FilterSelectFieldConfig,
        //
        {
            readonly: true,
            id: 'checkbox1',
            name: 'checkbox1',
            type: FieldTypeEnum.checkbox,
            label: {text: 'fields.checkbolasdl alsdalsdlads ladlaldlasdlasldas ldladlaldal dlasdlasld alsdlsax1'},
            hidden: false,
            required: true
        },

        //     {
        //         id: 'datetime1',
        //         name: 'datetime1',
        //         label: {text: 'fields.datetime1'},
        //         type: FieldTypeEnum.datetime,
        //         required: true,
        //         hidden: false,
        //         // readonly: true,
        //         value: new Date(2020, 0, 1),
        //     } as DatetimeFieldConfig,
        //     {
        //         id: 'time1',
        //         name: 'time1',
        //         type: FieldTypeEnum.time,
        //         label: {text: 'fields.time1'},
        //         required: true,
        //         // readonly: true,
        //         value: '12:00'
        //     },
        //     {
        //         id: 'button1',
        //         name: 'button1',
        //         type: FieldTypeEnum.button,
        //         label: {text: 'add'},
        //         hidden: false,
        //         // click: this.onButtonClick.bind(this),
        //         readonly: true,
        //         buttonIcon: 'delete'
        //         // customContent: ButtonComponentComponent,
        //     } ,
        //     {
        //         id: 'button3',
        //         name: 'button3',
        //         type: FieldTypeEnum.button,
        //         label: {text: 'update config'},
        //         hidden: false,
        //         // click: this.onButtonDelete.bind(this),
        //         readonly: true,
        //     },
        //     {
        //         id: 'icon1',
        //         name: 'icon1',
        //         type: FieldTypeEnum.icon,
        //         label: {text: 'fields.icon1'},
        //         value: 'search',
        //         readonly: true,
        //     },
        //     {
        //         id: 'image1',
        //         name: 'image1',
        //         type: FieldTypeEnum.image,
        //         label: {text: 'fields.image1'},
        //         width: '400px',
        //         height: '300px',
        //         value: 'https://i.ytimg.com/vi/1Ne1hqOXKKI/maxresdefault.jpg',
        //         // setSource: this.getImageSource,
        //         readonly: true,
        //     },
        //     {
        //         id: 'option1',
        //         name: 'option1',
        //         type: FieldTypeEnum.option,
        //         orientation: 'vertical',
        //         options: [{optionLabel: 'Paris', optionValue: 'Paris'}, {optionLabel: 'London', optionValue: 'London'}],
        //         readonly: true,
        //     },
        //     {
        //         id: 'toggle-slide',
        //         name: 'slidetoggle',
        //         type: FieldTypeEnum.slidetoggle,
        //         label: {text: 'fields.slidetoggle1'},
        //         required: true,
        //         allowLabelCollapse: false,
        //         slideToggleTooltip: 'asdasdasd',
        //         hint: {
        //             text: 'Lviv',
        //             class: 'custom-class',
        //             icon: {iconName: 'info', outlined: false, class: 'edit'}
        //         } as FieldHint,
        //         // readonly: true,
        //     } as SlideToggleFieldConfig,
        //     {
        //         id: 'toggle-slide1',
        //         name: 'slidetoggle1',
        //         type: FieldTypeEnum.slidetoggle,
        //         // value: true,
        //         label: {text: 'super'},
        //         required: true,
        //         allowLabelCollapse: true
        //
        //         // readonly: true,
        //     } as SlideToggleFieldConfig,
        {
            id: 'chips',
            name: 'chip-list',
            tooltip: {text: 'asdasdasdasdas'},
            type: FieldTypeEnum.chips,
            label: {text: 'chip list - two validators, every chip keeps its own error'},
            validators: [
                Validators.required,


                customChipListValidator(
                    (chip) => {
                        return {isValid: !chip?.text?.includes('_'), errorText: 'bla bla '}
                    },
                    'Entries must not contain "_"'
                ),

                customChipListValidator(
                    (chip) => {
                        return chip?.text?.includes('!')
                            ? {isValid: false, errorText: `"${chip.text}" contains an exclamation mark`}
                            : {isValid: true}
                    },
                    'Entries must not contain "!"'
                )
            ],
            // readonly: true,
            value: [
                {id: '1', text: 'plain text'},
                {id: '2', text: 'has_underscore'},
                {id: '3', text: 'has exclamation!'},
                {id: '4', text: 'has_both!'}
            ] as ChipItem[],

            options: {
                hideRemoveAll: true,
                viewType: ChipListViewTypeEnum.singleLine,
                addNewOptions: {
                    startAdding: 1
                }
            },
        } as ChipsFieldConfig,
        //     {
        //         id: 'fileSelect',
        //         name: 'fileSelect',
        //         type: FieldTypeEnum.fileSelect,
        //         label: {text: 'fields.fileSelect'},
        //         layoutOptions: {layout: 'list', headerVisibility: false},
        //         selectMultiple: true,
        //         required: true,
        //         // acceptedType: ['.doc', '.pdf', 'image/png'],
        //         value: null
        //
        //     }
        // ]

    ]


    public formConfig: DynamicFormConfig;

    public fieldsAreaOldValue = JSON.stringify(this.defaultFields);
    public fieldsAreaNewValue;
    public fieldsAreaError;
    public formErrors = true;
    public formVisibleErrors = false;
    public formAsterisc = false;
    public formInitValue;
    sendInfo = {ReplyTo: [], ReplyToAdresses: []};


    public stressNumberFieldCount = 100;


    public ngOnInit() {

        const fieldsAreaOldValue = localStorage.getItem('fieldsAreaOldValue') || this.fieldsAreaOldValue;
        if (fieldsAreaOldValue) {
            this.fieldsAreaOldValue = this.createFieldsData(fieldsAreaOldValue);
        }


        this.defaultFields = [
            ...this.defaultFields,
            ...this.buildStressNumberFields(this.stressNumberFieldCount)
        ];


        this.formConfig = {
            layouts: [this.buildFlexLayout(this.defaultFields)],
            name: 'form1',
            fields: this.defaultFields
        };
    }


    private buildStressNumberFields(count: number): NumberFieldConfig[] {
        return Array.from({length: count}, (_, i) => ({
            id: `stressNumber${i}`,
            name: `stressNumber${i}`,
            type: FieldTypeEnum.number,
            label: {text: `Stress number ${i + 1}`},
            value: 0,
            minValue: 0,
            required: true,
            numberType: NumberTypeEnum.integer,
            class: 'stress-number-field'
        } as NumberFieldConfig));
    }


    private buildFlexLayout(fields: any[]): FlexLayoutConfig {
        return {
            name: 'stress-layout',
            cols: [{col: 0, flex: '100'}],
            fields: fields.map((field, i) => ({
                fieldName: field.name,
                col: 0,
                row: i,
                layoutAlign: 'start start'
            }))
        } as FlexLayoutConfig;
    }

    public setFieldsArea(fieldsAreaValue) {
        if (!fieldsAreaValue) {
            return;
        }

        localStorage.setItem('fieldsAreaOldValue', fieldsAreaValue);
    }

    public modifyForm() {
        if (!this.fieldsAreaNewValue) {
            return;
        }
        this.defaultFields = JSON.parse(this.fieldsAreaNewValue);
        this.defaultFields.forEach((defaultField) => {
            // delete defaultField?.validators;
            // delete defaultField?.asyncValidators;
        });
        this.setFieldsArea(this.fieldsAreaNewValue);

        this.formConfig = {
            layouts: [],
            name: '',
            fields: []
        };

        setTimeout(() => {
            this.formConfig = {
                layouts: [this.buildFlexLayout(this.defaultFields)],
                name: '',
                fields: this.defaultFields
            };
        }, 200)

    }

    public fieldsAreaChange(data) {

        this.fieldsAreaNewValue = data;

        this.fieldsAreaError = false;
        try {
            if (data) {
                JSON.parse(data);
            }
        } catch (e) {
            this.fieldsAreaError = true;
        }
    }


    validDate(v: Date) {
        const val = this.dates.find((value) => {
            value.setHours(0, 0, 0, 0);
            if (value?.getTime() === v?.getTime()) {
                return true;
            }
        });
        if (val) {
            return true;
        }
    }

    public onReadyEvent(param: DynamicFormReadyEvent) {
        this.formData = param;
        this.formGroup = param.dynamicFormService.formGroup;
        this.formInitValue = this.formGroup.value;

        this.formData.dynamicFormEventsService.onFieldValueChanged
            .subscribe((value: any) => {
                console.log(value)

                if (value?.config?.name?.startsWith('stressNumber')) {
                    this.formData.dynamicFormService.updateFieldConfig({
                        name: value.config.name,
                        hint: {text: `x2 = ${(+value.value || 0) * 2}`, class: 'custom-class'} as FieldHint
                    });
                }
            })

        this.formData.dynamicFormEventsService.onControlClick
            .subscribe(e => {

                // console.log(e)
            });
        // this.formData.dynamicFormEventsService.onControlSuffixClick.subscribe(value => console.log(value));
        setTimeout(() => {
            this.formData.dynamicFormValidationService.formErrors$
                .pipe(untilDestroyed(this))
                .subscribe(errors => {
                    this.formErrors = false;
                    this.formVisibleErrors = false;

                    if (Object.keys(errors).length === 0) {
                        return;
                    }

                    this.formErrors = true;
                    for (const error of Object.values(errors)) {
                        if ((error as ValidationError).errorVisible) {
                            this.formVisibleErrors = true;
                            this.formAsterisc = this.formVisibleErrors;

                            return;
                        }
                    }

                    if (JSON.stringify(this.formGroup.value) === JSON.stringify(this.formInitValue)) {
                        this.formAsterisc = this.formVisibleErrors;
                    }
                });

            this.formGroup.valueChanges
                .pipe(untilDestroyed(this))
                .subscribe(formValue => {
                    if (JSON.stringify(formValue) === JSON.stringify(this.formInitValue)) {
                        this.formAsterisc = this.formVisibleErrors;

                        return;
                    }

                    this.formAsterisc = true;
                });
        });
        this.formData.dynamicFormService.autoFill();
    }

    public submitClick() {
        this.formConfig = {
            layouts: [],
            name: '',
            fields: [
                {
                    id: 'date1',
                    name: 'date1',
                    type: FieldTypeEnum.date,
                    label: {text: 'fields.date1'},
                    required: false,
                    disabled: false,
                    // readonly: true,
                    // readonly: true,
                    // maxDate: new Date(2020, 0, 1),
                    hidden: false,
                    // getDateClass: this.setDateClassValue.bind(this),
                    // dateFilter: this.validDate.bind(this),
                    value: null,
                } as DateFieldConfig,]
        };
    }

    public ngOnDestroy() {
    }

    updateChipList() {
        // this.loadSendForm();
        this.formData.dynamicFormService.updateFieldConfig({
            name: 'text1',
            hint: {
                text: 'Lviv',
                class: 'custom-class',
                icon: {iconName: 'delete', outlined: false, class: 'edit'}
            } as FieldHint,
        });
    }

    loadSendForm() {

        const fromChip: ChipItem = {
            text: 'this.sendInfo.From',
            readonly: true
        };
        this.formData.dynamicFormService.updateFieldValue('chip-list', [fromChip]);
        const replyToChips: ChipItem[] = [];
        if (this.sendInfo.ReplyTo && this.sendInfo.ReplyTo.length > 0) {
            this.sendInfo.ReplyTo.filter(r => !!r).forEach(r =>
                replyToChips.push({text: r})
            );
        }
        this.formData.dynamicFormService.updateFieldValue('chip-list', replyToChips);
        const replyToListChips: ChipItem[] = [];
        if (this.sendInfo.ReplyToAdresses && this.sendInfo.ReplyToAdresses.length > 0) {
            this.sendInfo.ReplyToAdresses.filter(r => r.Email).forEach(r =>
                replyToListChips.push({text: r.Email})
            );
        }

        const options = {
            hideRemoveAll: false,
            viewType: ChipListViewTypeEnum.multiLine,
            addNewOptions: {
                startAdding: 1,
                getAutocompleteSource: null
            }
        };
        options.addNewOptions.getAutocompleteSource = async () => replyToListChips;
        this.formData.dynamicFormService.updateFieldConfig({name: 'chip-list', options} as ChipsFieldConfig);
    }

    public customSearchFn(term: string, item: any): boolean {
        return item.text.startsWith(term);
    }

    base64toBlob(base64Data, contentType) {
        contentType = contentType || '';
        const sliceSize = 1024;
        const byteCharacters = atob(base64Data);
        const bytesLength = byteCharacters.length;
        const slicesCount = Math.ceil(bytesLength / sliceSize);
        const byteArrays = new Array(slicesCount);

        for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            const begin = sliceIndex * sliceSize;
            const end = Math.min(begin + sliceSize, bytesLength);

            const bytes = new Array(end - begin);
            for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, {type: contentType});
    }

    private onButtonClick() {
        // debugger
        this.formData.dynamicFormService.updateFieldConfig({
            name: 'number1',
            validators: [Validators.max(22)]
            // value: 23
        })


    }

    private onButtonDelete() {
        this.formData.dynamicFormService.updateFieldConfig({
            name: 'fileSelect',
            value: [this.base64toBlob(randomImage2, 'image/png'), this.base64toBlob(randomImage3, 'image/png')],
        })
    }

    private async getImageSource(): Promise<string> {
        return 'data:image/gif;base64,R0lGODlhDwAPAKECAAAAzMzM/////wAAACwAAAAADwAPAAACIISPeQHsrZ5ModrLl' +
            'N48CXF8m2iQ3YmmKqVlRtW4MLwWACH+H09wdGltaXplZCBieSBVbGVhZCBTbWFydFNhdmVyIQAAOw==';
    }

    private async getSelectSource(): Promise<SelectItem[]> {
        return [{text: 'loadedItem1', id: 'loadedItem1'}, {text: 'loadedItem2', id: 'loadedItem2'}];
    }

    // private badWordValidator(control: AbstractControl): CustomValidationError {
    //     if (control.value && control.value.toLowerCase() === 'bad word') {
    //         return {
    //             mydocmaCustomError: 'bad words are not allowed'
    //         };
    //     }
    // }

    // private async allBadWordValidator(control: AbstractControl): Promise<CustomValidationError> {
    //     if (control.value && control.value.toLowerCase().trim().startsWith('bad word')) {
    //         return {
    //             mydocmaCustomError: 'all bad words are not allowed'
    //         };
    //     }
    // }

    private createFieldsData(data) {
        if (!data) {
            return [];
        }

        return typeof data === 'string'
            ? JSON.parse(data)
            : data;
    }

    private setDateClassValue(value): string {
        if (value === 1 || value === 20) {
            return 'example-custom-date-class';
        } else {
            return ''
        }
    }
}
